import { LodashUtilityService } from './lodash-utility-service';

export class ObjectUtilityService {
	static replaceNullOrUndefined(
		object: object,
		replaceValue: any = ''
	): object {
		const replacer = (key, value) =>
			LodashUtilityService.isNil(value) ? replaceValue : value;

		return JSON.parse(JSON.stringify(object, replacer));
	}

	static removeObjectProperty(
		objectToModify: object,
		valueToRemove: any
	): object {
		const newObject = {};
		Object.keys(objectToModify).forEach((prop) => {
			if (objectToModify[prop] !== valueToRemove) {
				newObject[prop] = objectToModify[prop];
			}
		});

		return newObject;
	}

	static pickObjectProps(object: object, ...propsToPick): object {
		return propsToPick.reduce((accumulator: object, prop: string) => {
			if (object.hasOwnProperty(prop)) {
				accumulator[prop] = object[prop];
			}

			return accumulator;
		}, {});
	}
}
